import navigation from "../../containers/_nav";
import { initialState } from "@prominentmedia/coreredux"; 


export default{
	...initialState,	
	sidebarShow: "responsive",	
	showCompleteProjects: false,
	sidebarNavItems: navigation,	
	projectPhasesTableOpen: [],
	projectInvoicesTableOpen:[],
	engineerReports:[],
	usersList: [],
	users: [],
	userListUpdateRequired: true,
	contactsList:[],
	contacts:[],
	contactListUpdateRequired: true,
	organisationsList:[],
	organisations:[],
	organisationListUpdateRequired: true,
	projectsIdsNeedingUpdate:[],
	phases:[],
	projectsList: [],	
	projects:[],
	projectListUpdateRequired: true,
	organisationIdsNeedingUpdate:[],
	projectsWithPhasesList:[],
	projectItems: [],
	projectItemIdsNeedingUpdate:[],	
	projectItemActivitys:[],		
	projectItemMilestones:[],
	projectItemStatussList:[],			
	projectItemTypesList:[],		
	projectTypesList:[],		
	sitesList:[],
	sites:[],
	siteListUpdateRequired: true,
	milestoneTemplatesList:[],
	milestoneTemplates: [],
	milestoneTemplateListUpdateRequired: true,
	milestoneTemplateIdsNeedingUpdate:[],
	milestoneTemplateEntrys:[]	
};